<template>
    <div>
        <compWrapper
            :title="
                $t('erp.b2border.salesman_information', {
                    defaultValue: '资源信息'
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-15 clearfix"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <div v-if="type != 'query'" class="text-right margin-right-15">
                <vButton theme="primary" @click="submit">{{
                    $t("global.common.save", { defaultValue: "保存" })
                }}</vButton>
                <vButton class="margin-left-10" @click="cancel">{{
                    $t("global.common.operate_cancel", { defaultValue: "取消" })
                }}</vButton>
            </div>
        </compWrapper>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

import {
    HttpGetResourceOne,
    HttpSaveResource
} from "@/service/products/promotion";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit")
        // compLog: () => import("./log"),
    },
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            sourceType: this.$route.query.sourceType,
            formData: {
                type: 1
            },
            loading:false
        };
    },
    created() {
        this.update();
    },
    computed: {
        getBase() {
            return [
                {
                    label: "国家",
                    key: "countryCode"
                },
                {
                    label: "名称",
                    key: "resourcesName",
                    query: this.type != "add"
                },
                {
                    label: "网址",
                    key: "resourcesUrl",
                    query: this.type != "add"
                },
                {
                    label: "alexa全球排名",
                    key: "alexaRank",
                    required: false
                },
                {
                    label: "网站流量",
                    key: "linkFlow",
                    required: false
                },
                {
                    label: "网站特点",
                    key: "sitePeculiarity"
                },
                {
                    label: "合作方式",
                    key: "cooperationType"
                },
                {
                    label: "合作条款",
                    key: "cooperationTerms"
                },
                {
                    label: "合作状态",
                    key: "cooperationStatus",
                    tag: "vSelect",
                    options: [
                        {
                            value: 1,
                            label: "洽谈中"
                        },
                        {
                            value: 2,
                            label: "合作中"
                        },
                        {
                            value: 3,
                            label: "已排除"
                        },
                        {
                            value: 4,
                            label: "黑名单"
                        }
                    ]
                },
                {
                    label: "联系人",
                    key: "contact"
                },
                {
                    label: "联系方式",
                    key: "contactType"
                },
                {
                    label: "付款方式",
                    key: "payType"
                },
                {
                    label: "平台",
                    key: "platform",
                    required: false
                },
                {
                    label: "粉丝范围",
                    key: "fanVolume",
                    required: false
                },
                {
                    label: "费用",
                    key: "cost",
                    required: false
                },
                {
                    label: "收款账号",
                    key: "accountNumber",
                    required: false
                },
                {
                    label: "属性",
                    key: "attribute",
                    required: false
                },
                {
                    label: "回复时间",
                    key: "replyTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd"
                    }
                },
                {
                    label: "备注",
                    key: "remark",
                    required: false
                }
            ];
        }
    },
    methods: {
        ...mapMutations("diction", ["clearStore"]),
        update() {
            if (this.type == "add") return;
            if (this.activeids) {
                this.id = this.activeids;
                this.type = this.querytype;
            } else {
                this.id = this.id;
                this.type = this.type;
            }
            HttpGetResourceOne({
                id: this.id
            }).then(
                res => {
                    this.formData = res.data;
                },
                err => {}
            );
        },
        async submit() {
            let bool3 = await this.$refs.editform.validate();
            if (!bool3) {
                return;
            }
            this.formData.type = this.sourceType;
            this.loading = true;
            HttpSaveResource({
                ...this.formData,
                orgId: global.SYSID
            }).then(
                res => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                err => {
                    this.loading = false;
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                }
            );
        },
        cancel() {
            this.$router.push({
                name: "promotionResourceList"
            });
        }
    }
};
</script>
